/**
 * LoginTagline – "Train" + rotating word.
 * All vision/ML types cycle: Classification, Detection, Segmentation, Tracking, Recognition, Localization.
 * Alphabet-level animation: letters appear one after another. Single theme color.
 */
import React, { useState, useEffect, useRef } from 'react';
import './LoginTagline.scss';

const ROTATING_WORDS = [
  'Classification',
  'Detection',
  'Segmentation',
  'Tracking',
  'Recognition',
  'Localization',
];
const ROTATE_INTERVAL_MS = 3200;
const STAGGER_MS = 120;

export default function LoginTagline() {
  const [index, setIndex] = useState(0);
  const [isLeaving, setIsLeaving] = useState(false);
  const indexRef = useRef(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIsLeaving(true);
      setTimeout(() => {
        indexRef.current = (indexRef.current + 1) % ROTATING_WORDS.length;
        setIndex(indexRef.current);
        setIsLeaving(false);
      }, 400);
    }, ROTATE_INTERVAL_MS);
    return () => clearInterval(t);
  }, []);

  const word = ROTATING_WORDS[index];
  const trainChars = 'Train'.split('');
  const wordChars = word.split('');

  return (
    <div className="login-tagline">
      <span className="login-tagline__static" aria-hidden="true">
        {trainChars.map((c, i) => (
          <span
            key={`train-${i}`}
            className="login-tagline__char login-tagline__char--train"
            style={{ animationDelay: `${i * STAGGER_MS}ms` }}
          >
            {c}
          </span>
        ))}
      </span>
      <span className="login-tagline__rotating-wrapper">
        <span
          className={`login-tagline__word ${isLeaving ? 'login-tagline__word--out' : 'login-tagline__word--in'}`}
          key={word}
          aria-live="polite"
        >
          {wordChars.map((c, i) => (
            <span
              key={`${word}-${i}-${c}`}
              className="login-tagline__char login-tagline__char--rotating"
              style={{ animationDelay: `${i * STAGGER_MS}ms` }}
            >
              {c}
            </span>
          ))}
        </span>
      </span>
    </div>
  );
}
